export const routerPaths = {
  '/pack-delivery/:imageId.webp'(params: { imageId_webp: string | number }) {
    return buildPath('/pack-delivery/:imageId.webp', params)
  },
  '/api/model/session-photos': '/api/model/session-photos',
  '/auth/:provider/callback'(params: { provider: string | number }) {
    return buildPath('/auth/:provider/callback', params)
  },
  '/muse-samples/:slug/:file'(params: { slug: string | number, file: string | number }) {
    return buildPath('/muse-samples/:slug/:file', params)
  },
  '/static/ovid/veil/t/:file'(params: { file: string | number }) {
    return buildPath('/static/ovid/veil/t/:file', params)
  },
  '/auth/magic-link/verify': '/auth/magic-link/verify',
  '/pack-samples/:slug/:id'(params: { slug: string | number, id: string | number }) {
    return buildPath('/pack-samples/:slug/:id', params)
  },
  '/static/ovid/veil/:file'(params: { file: string | number }) {
    return buildPath('/static/ovid/veil/:file', params)
  },
  '/auth/magic-link/code': '/auth/magic-link/code',
  '/api/pack/entitlement': '/api/pack/entitlement',
  '/api/generate/stream': '/api/generate/stream',
  '/api/model/set-check': '/api/model/set-check',
  '/api/pack/run-status': '/api/pack/run-status',
  '/auth/google/one-tap': '/auth/google/one-tap',
  '/previews/:rowId/:n'(params: { rowId: string | number, n: string | number }) {
    return buildPath('/previews/:rowId/:n', params)
  },
  '/api/model/verify': '/api/model/verify',
  '/generations/:key'(params: { key: string | number }) {
    return buildPath('/generations/:key', params)
  },
  '/api/model/photo': '/api/model/photo',
  '/api/model/start': '/api/model/start',
  '/auth/magic-link': '/auth/magic-link',
  '/api/pack-queue': '/api/pack-queue',
  '/auth/:provider'(params: { provider: string | number }) {
    return buildPath('/auth/:provider', params)
  },
  '/consent/accept': '/consent/accept',
  '/indexnow.txt': '/indexnow.txt',
  '/checkout/muse': '/checkout/muse',
  '/checkout/plan': '/checkout/plan',
  '/sitemap.xml': '/sitemap.xml',
  '/stripe-portal': '/stripe-portal',
  '/wall/suggest': '/wall/suggest',
  '/robots.txt': '/robots.txt',
  '/auth/logout': '/auth/logout',
  '/chain/:root'(params: { root: string | number }) {
    return buildPath('/chain/:root', params)
  },
  '/auth/login': '/auth/login',
  '/look/:file'(params: { file: string | number }) {
    return buildPath('/look/:file', params)
  },
  '/continue': '/continue',
  '/tile/:id'(params: { id: string | number }) {
    return buildPath('/tile/:id', params)
  },
  '/': '/',
  '/muse/:museSlug'(params: { museSlug: string | number }) {
    return buildPath('/muse/:museSlug', params)
  },
  '/account/packs': '/account/packs',
  '/:packSlug'(params: { packSlug: string | number }) {
    return buildPath('/:packSlug', params)
  },
  '/atelier': '/atelier',
  '/privacy': '/privacy',
  '/packs': '/packs',
  '/proof': '/proof',
  '/terms': '/terms',
  '/feed': '/feed',
  '/muse': '/muse',
  '/webhook': '/webhook',
  '/health': '/health',
  '/touch': '/touch',
  '/mine': '/mine',
  '/mine/muses': '/mine/muses',
  '/mine/muse': '/mine/muse',
  '/seen': '/seen',
  '/wall': '/wall',
  '/pin': '/pin'
} as const

export const unsafeRouterPaths = {
  '/pack-delivery/:imageId.webp'(params: Record<string, unknown>) {
    return unsafeBuildPath('/pack-delivery/:imageId.webp', params)
  },
  '/api/model/session-photos'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/model/session-photos', params)
  },
  '/auth/:provider/callback'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/:provider/callback', params)
  },
  '/muse-samples/:slug/:file'(params: Record<string, unknown>) {
    return unsafeBuildPath('/muse-samples/:slug/:file', params)
  },
  '/static/ovid/veil/t/:file'(params: Record<string, unknown>) {
    return unsafeBuildPath('/static/ovid/veil/t/:file', params)
  },
  '/auth/magic-link/verify'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/magic-link/verify', params)
  },
  '/pack-samples/:slug/:id'(params: Record<string, unknown>) {
    return unsafeBuildPath('/pack-samples/:slug/:id', params)
  },
  '/static/ovid/veil/:file'(params: Record<string, unknown>) {
    return unsafeBuildPath('/static/ovid/veil/:file', params)
  },
  '/auth/magic-link/code'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/magic-link/code', params)
  },
  '/api/pack/entitlement'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/pack/entitlement', params)
  },
  '/api/generate/stream'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/generate/stream', params)
  },
  '/api/model/set-check'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/model/set-check', params)
  },
  '/api/pack/run-status'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/pack/run-status', params)
  },
  '/auth/google/one-tap'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/google/one-tap', params)
  },
  '/previews/:rowId/:n'(params: Record<string, unknown>) {
    return unsafeBuildPath('/previews/:rowId/:n', params)
  },
  '/api/model/verify'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/model/verify', params)
  },
  '/generations/:key'(params: Record<string, unknown>) {
    return unsafeBuildPath('/generations/:key', params)
  },
  '/api/model/photo'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/model/photo', params)
  },
  '/api/model/start'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/model/start', params)
  },
  '/auth/magic-link'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/magic-link', params)
  },
  '/api/pack-queue'(params: Record<string, unknown>) {
    return unsafeBuildPath('/api/pack-queue', params)
  },
  '/auth/:provider'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/:provider', params)
  },
  '/consent/accept'(params: Record<string, unknown>) {
    return unsafeBuildPath('/consent/accept', params)
  },
  '/indexnow.txt'(params: Record<string, unknown>) {
    return unsafeBuildPath('/indexnow.txt', params)
  },
  '/checkout/muse'(params: Record<string, unknown>) {
    return unsafeBuildPath('/checkout/muse', params)
  },
  '/checkout/plan'(params: Record<string, unknown>) {
    return unsafeBuildPath('/checkout/plan', params)
  },
  '/sitemap.xml'(params: Record<string, unknown>) {
    return unsafeBuildPath('/sitemap.xml', params)
  },
  '/stripe-portal'(params: Record<string, unknown>) {
    return unsafeBuildPath('/stripe-portal', params)
  },
  '/wall/suggest'(params: Record<string, unknown>) {
    return unsafeBuildPath('/wall/suggest', params)
  },
  '/robots.txt'(params: Record<string, unknown>) {
    return unsafeBuildPath('/robots.txt', params)
  },
  '/auth/logout'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/logout', params)
  },
  '/chain/:root'(params: Record<string, unknown>) {
    return unsafeBuildPath('/chain/:root', params)
  },
  '/auth/login'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/login', params)
  },
  '/look/:file'(params: Record<string, unknown>) {
    return unsafeBuildPath('/look/:file', params)
  },
  '/continue'(params: Record<string, unknown>) {
    return unsafeBuildPath('/continue', params)
  },
  '/tile/:id'(params: Record<string, unknown>) {
    return unsafeBuildPath('/tile/:id', params)
  },
  '/'(params: Record<string, unknown>) {
    return unsafeBuildPath('/', params)
  },
  '/muse/:museSlug'(params: Record<string, unknown>) {
    return unsafeBuildPath('/muse/:museSlug', params)
  },
  '/account/packs'(params: Record<string, unknown>) {
    return unsafeBuildPath('/account/packs', params)
  },
  '/:packSlug'(params: Record<string, unknown>) {
    return unsafeBuildPath('/:packSlug', params)
  },
  '/atelier'(params: Record<string, unknown>) {
    return unsafeBuildPath('/atelier', params)
  },
  '/privacy'(params: Record<string, unknown>) {
    return unsafeBuildPath('/privacy', params)
  },
  '/packs'(params: Record<string, unknown>) {
    return unsafeBuildPath('/packs', params)
  },
  '/proof'(params: Record<string, unknown>) {
    return unsafeBuildPath('/proof', params)
  },
  '/terms'(params: Record<string, unknown>) {
    return unsafeBuildPath('/terms', params)
  },
  '/feed'(params: Record<string, unknown>) {
    return unsafeBuildPath('/feed', params)
  },
  '/muse'(params: Record<string, unknown>) {
    return unsafeBuildPath('/muse', params)
  },
  '/webhook'(params: Record<string, unknown>) {
    return unsafeBuildPath('/webhook', params)
  },
  '/health'(params: Record<string, unknown>) {
    return unsafeBuildPath('/health', params)
  },
  '/touch'(params: Record<string, unknown>) {
    return unsafeBuildPath('/touch', params)
  },
  '/mine'(params: Record<string, unknown>) {
    return unsafeBuildPath('/mine', params)
  },
  '/mine/muses'(params: Record<string, unknown>) {
    return unsafeBuildPath('/mine/muses', params)
  },
  '/mine/muse'(params: Record<string, unknown>) {
    return unsafeBuildPath('/mine/muse', params)
  },
  '/seen'(params: Record<string, unknown>) {
    return unsafeBuildPath('/seen', params)
  },
  '/wall'(params: Record<string, unknown>) {
    return unsafeBuildPath('/wall', params)
  },
  '/pin'(params: Record<string, unknown>) {
    return unsafeBuildPath('/pin', params)
  }
} as const

export type RouterPath = keyof typeof routerPaths

export type RouterParams = {
  '/pack-delivery/:imageId.webp': { imageId_webp: string },
  '/api/model/session-photos': {  },
  '/auth/:provider/callback': { provider: string },
  '/muse-samples/:slug/:file': { slug: string, file: string },
  '/static/ovid/veil/t/:file': { file: string },
  '/auth/magic-link/verify': {  },
  '/pack-samples/:slug/:id': { slug: string, id: string },
  '/static/ovid/veil/:file': { file: string },
  '/auth/magic-link/code': {  },
  '/api/pack/entitlement': {  },
  '/api/generate/stream': {  },
  '/api/model/set-check': {  },
  '/api/pack/run-status': {  },
  '/auth/google/one-tap': {  },
  '/previews/:rowId/:n': { rowId: string, n: string },
  '/api/model/verify': {  },
  '/generations/:key': { key: string },
  '/api/model/photo': {  },
  '/api/model/start': {  },
  '/auth/magic-link': {  },
  '/api/pack-queue': {  },
  '/auth/:provider': { provider: string },
  '/consent/accept': {  },
  '/indexnow.txt': {  },
  '/checkout/muse': {  },
  '/checkout/plan': {  },
  '/sitemap.xml': {  },
  '/stripe-portal': {  },
  '/wall/suggest': {  },
  '/robots.txt': {  },
  '/auth/logout': {  },
  '/chain/:root': { root: string },
  '/auth/login': {  },
  '/look/:file': { file: string },
  '/continue': {  },
  '/tile/:id': { id: string },
  '/': {  },
  '/muse/:museSlug': { museSlug: string },
  '/account/packs': {  },
  '/:packSlug': { packSlug: string },
  '/atelier': {  },
  '/privacy': {  },
  '/packs': {  },
  '/proof': {  },
  '/terms': {  },
  '/feed': {  },
  '/muse': {  },
  '/webhook': {  },
  '/health': {  },
  '/touch': {  },
  '/mine': {  },
  '/mine/muses': {  },
  '/mine/muse': {  },
  '/seen': {  },
  '/wall': {  },
  '/pin': {  }
}

type InputParams = {
  '/pack-delivery/:imageId.webp': { imageId_webp: string | number },
  '/api/model/session-photos': {  },
  '/auth/:provider/callback': { provider: string | number },
  '/muse-samples/:slug/:file': { slug: string | number, file: string | number },
  '/static/ovid/veil/t/:file': { file: string | number },
  '/auth/magic-link/verify': {  },
  '/pack-samples/:slug/:id': { slug: string | number, id: string | number },
  '/static/ovid/veil/:file': { file: string | number },
  '/auth/magic-link/code': {  },
  '/api/pack/entitlement': {  },
  '/api/generate/stream': {  },
  '/api/model/set-check': {  },
  '/api/pack/run-status': {  },
  '/auth/google/one-tap': {  },
  '/previews/:rowId/:n': { rowId: string | number, n: string | number },
  '/api/model/verify': {  },
  '/generations/:key': { key: string | number },
  '/api/model/photo': {  },
  '/api/model/start': {  },
  '/auth/magic-link': {  },
  '/api/pack-queue': {  },
  '/auth/:provider': { provider: string | number },
  '/consent/accept': {  },
  '/indexnow.txt': {  },
  '/checkout/muse': {  },
  '/checkout/plan': {  },
  '/sitemap.xml': {  },
  '/stripe-portal': {  },
  '/wall/suggest': {  },
  '/robots.txt': {  },
  '/auth/logout': {  },
  '/chain/:root': { root: string | number },
  '/auth/login': {  },
  '/look/:file': { file: string | number },
  '/continue': {  },
  '/tile/:id': { id: string | number },
  '/': {  },
  '/muse/:museSlug': { museSlug: string | number },
  '/account/packs': {  },
  '/:packSlug': { packSlug: string | number },
  '/atelier': {  },
  '/privacy': {  },
  '/packs': {  },
  '/proof': {  },
  '/terms': {  },
  '/feed': {  },
  '/muse': {  },
  '/webhook': {  },
  '/health': {  },
  '/touch': {  },
  '/mine': {  },
  '/mine/muses': {  },
  '/mine/muse': {  },
  '/seen': {  },
  '/wall': {  },
  '/pin': {  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function buildPath<TRouterPath extends RouterPath>(route: TRouterPath, params: InputParams[TRouterPath]) {
  return route
    .replace(/'/g, '')
    .split('/')
    .map((part) =>
      part.startsWith(':') ? params[part.replace(':', '').replace('?', '') as keyof InputParams[TRouterPath]] : part,
    )
    .filter((part) => part !== undefined)
    .join('/')
}

function unsafeBuildPath<TRouterPath extends RouterPath>(
  route: TRouterPath,
  params: Record<string, unknown>,
) {
  return route
    .replace(/'/g, '')
    .split('/')
    .map((part) => (part.startsWith(':') ? params[part.replace(':', '').replace('?', '')] : part))
    .filter((part) => part !== undefined)
    .join('/')
}
